import ItemViewState from '../../store/schema/ItemViewState';
import { mutatorAction } from 'satcheljs';

// This property counts the number of repeated likes/unlikes the user has performed locally on the client.
// If the number exceeds MaxLocalLikes, the client UI continues to be updated but no action is sent to the server.
// This is to minimize the impact of repeated like/unlike/like/unlike...

export const initializeLikeUnlikeTracker = mutatorAction(
    'initializeLikeUnlikeTracker',
    (viewState: ItemViewState) => {
        viewState.likeUnlikeTracker = {
            likeButtonClickCount: 0,
            likeUnlikeInProgress: false,
        };
    }
);
